<!-- Page : carikartmuhkodupdateexcel.vue -->

<template>
  <div>
    <carikartmuhkodupdatebase
    
     
      v-model="items"
      v-on:submitfile="SubmitFile"
      :status="status"
      :menuitems="menuItems"
      v-on:menuclick="menuClick"
     
    ></carikartmuhkodupdatebase>
  </div>
</template>
  
  <script>
import carikartmuhkodupdatebase from "@/components/app/cari/yardimciislemler/carikartmuhkodupdatebase.vue";
import tool from "@/components/app/coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "@/api/auth";

export default {
  data() {
    return {
      items: [],
      status: tool.NewSatatus(),
      menuItems: [
        {
          title: this.$t('Download-Sample-File'),
        },
      ],
    };
  },

  components: {
    carikartmuhkodupdatebase,
  },
  methods: {
    menuClick(index) {
      if (index == 0) {
        this.DownloadFile("CariKartMuhKodUpdate.xlsx");
      } else if (index == 1) {
      }
    },

    DownloadFile(file) {
      var prm = {
        FileName: file,
      };

      this.status.loading = true;
      setTimeout(() => {
        tool.api_post_FileDownload(this, "CariStream/DownloadFile", prm).then(
          (response) => {
            tool.CreateDownloadLink(response, file);
            this.status.loading = false;
          },
          (response) => {
            this.status = tool.responseToStatus(response);
          }
        );
      }, 5000);
    },

    SubmitFile(files) {
      let formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        let file = files[i];
        formData.append("files[" + i + "]", file);
      }

      this.status.loading = true;
      tool.api_file_post(this, "CariStream/ExcelCariKartMuhKodUpdate", formData).then(
        (response) => {
          this.items = response.body;
          this.status.loading = false;
        },
        (response) => {
          this.status = tool.responseToStatus(response);
        }
      );
    },
  },
};
</script>
  